export const INSPECTOR_TITLE_TYPE_LABEL = {
  joint: "Joint",
  actuator: "Actuator",
  body: "Body",
  object: "Object",
  mesh: "Mesh",
  visual: "Visual",
  site: "Site",
  collision: "Collision",
  inertial: "Inertial",
  equality: "Constraint",
  tendon: "Tendon",
  camera: "Camera",
  light: "Light",
};

export const isSameInspectorTarget = (left, right) =>
  left?.type === right?.type && left?.id === right?.id;

export const collectDescendantBodyUuids = (sourceBodyUuid, bodies) => {
  if (!sourceBodyUuid) return new Set();
  const descendants = new Set();
  const stack = [sourceBodyUuid];
  while (stack.length > 0) {
    const current = stack.pop();
    if (!current || descendants.has(current)) continue;
    descendants.add(current);
    const body = bodies?.[current];
    const children = Array.isArray(body?.children) ? body.children : [];
    children.forEach((childUuid) => {
      if (childUuid && !descendants.has(childUuid)) stack.push(childUuid);
    });
  }
  return descendants;
};

export const getGeomUuidFromSelectionKey = (selectionKey) => {
  if (!selectionKey) return null;
  const str = String(selectionKey);
  const sepIdx = str.indexOf(":");
  return sepIdx >= 0 ? str.slice(sepIdx + 1) : str;
};

export const canDeleteAutoParentBodyForItem = (bodies, parentBodyUuid, itemType, itemUuid) => {
  const body = bodies?.[parentBodyUuid];
  if (!body) return false;
  const children = Array.isArray(body.children) ? body.children : [];
  const joints = Array.isArray(body.joints) ? body.joints : [];
  const sites = Array.isArray(body.sites) ? body.sites : [];
  const geoms = Array.isArray(body.geoms) ? body.geoms : [];
  if (children.length > 0 || body.inertia) return false;
  if (itemType === "joint") {
    return (
      joints.length === 1 &&
      String(joints[0]) === String(itemUuid) &&
      sites.length === 0 &&
      geoms.length === 0
    );
  }
  if (itemType === "site") {
    return (
      sites.length === 1 &&
      String(sites[0]) === String(itemUuid) &&
      joints.length === 0 &&
      geoms.length === 0
    );
  }
  if (itemType === "geom") {
    return (
      geoms.length === 1 &&
      String(geoms[0]?.uuid) === String(itemUuid) &&
      joints.length === 0 &&
      sites.length === 0
    );
  }
  return false;
};

export const isTextEditingTarget = (target) => {
  if (!target || typeof target.closest !== "function") return false;
  if (target.closest("[contenteditable='true']")) return true;
  const tagName = String(target.tagName || "").toLowerCase();
  return tagName === "input" || tagName === "textarea" || tagName === "select";
};

export const areResolvedGeomRefsEqual = (prev, next) => {
  if (prev === next) return true;
  if (!prev || !next) return false;
  const prevGeom = prev.geom || null;
  const nextGeom = next.geom || null;
  const prevUuid = prevGeom?.uuid != null ? String(prevGeom.uuid) : null;
  const nextUuid = nextGeom?.uuid != null ? String(nextGeom.uuid) : null;
  return (
    prev.bodyUuid === next.bodyUuid &&
    prevUuid === nextUuid &&
    prevGeom?.name === nextGeom?.name &&
    prevGeom?.kind === nextGeom?.kind &&
    prevGeom?.type === nextGeom?.type &&
    (prevGeom?.visualOnly === true) === (nextGeom?.visualOnly === true)
  );
};

export const findVisualGeomNodeForMesh = (bodies, meshUuid) => {
  if (!meshUuid) return null;
  for (const body of Object.values(bodies || {})) {
    if (!body?.uuid || !Array.isArray(body.geoms)) continue;
    const geom = body.geoms.find(
      (candidate) =>
        candidate?.visualOnly === true &&
        candidate?.uuid &&
        String(candidate.mesh || "") === String(meshUuid)
    );
    if (geom) return { bodyUuid: body.uuid, geom };
  }
  return null;
};
